import { useCallback, useRef } from "react";
import { defineMessages } from "react-intl";

import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import ConfirmationModal from "../Modals/ConfirmationModal";

const ProfileAnonymizationForm = _props => {
  const openConfirmModalRef = useRef(() => {});

  const t = useFormatMessage();
  const title = t(intlMessages.title);
  const description = t(intlMessages.description, { p: message => `<p>${message}</p>` });
  const buttonLabel = t(intlMessages.buttonLabel);
  const confirmationMessage = t(intlMessages.confirmationMessage, {
    p: message => `<p>${message}</p>`
  });
  const confirmAnonymization = t(intlMessages.confirmAnonymization);
  const cancelAnonymization = t(intlMessages.cancelAnonymization);

  const { pathFor } = useRoutesContext();
  // This function allows you to make a post to a route rails
  // for this we have created an empty form to request the route
  const navigateToAnonymizationPage = useCallback(() => {
    const pathName = pathFor("anonymization");

    const form = document.createElement("form");
    form.method = "post";
    form.action = pathName;

    document.body.appendChild(form);
    form.submit();
  }, [pathFor]);

  const handleButtonClicked = useCallback(() => {
    openConfirmModalRef.current && openConfirmModalRef.current();
  }, []);

  return (
    <>
      <div className="border-top margin-top-md">
        <h2 className="text-subtitle-page margin-y-sm">{title}</h2>

        <div className="bg-light padding-sm shadow">
          <div dangerouslySetInnerHTML={{ __html: description }} />

          <Button
            type="button"
            className="btn btn-primary btn-md margin-top-sm"
            label={buttonLabel}
            iconClassName="icon-suppr"
            onClick={handleButtonClicked}
          />
        </div>
      </div>

      <ConfirmationModal
        title={title}
        message={confirmationMessage}
        confirmButtonLabel={confirmAnonymization}
        openRef={openConfirmModalRef}
        onConfirm={navigateToAnonymizationPage}
        closeOnConfirm={true}
        cancelButtonLabel={cancelAnonymization}
      />
    </>
  );
};

export default ProfileAnonymizationForm;

const intlMessages = defineMessages({
  title: {
    id: "profile.anonymization.title",
    defaultMessage: "Anonymisation des données"
  },
  description: {
    id: "profile.anonymization.description",
    defaultMessage: `
      <p>
        Lorsque vous décidez d'anonymiser vos données, l'ensemble de vos données
        personnelles seront remplacées par des données factices, sur l'ensemble de la
        plateforme. Vos contributions publiques ou réponses à des questionnaires
        apparaîtront de manière anonyme, y compris pour les administrateurs de la
        plateforme.
      </p>
      <p>
        Aussi, votre adresse e-mail sera remplacée et vous n'aurez donc plus accès à votre
        compte utilisateur. Vous serez donc automatiquement déconnecté de votre compte.
        Notez qu'il ne sera donc pas possible pour un administrateur de vous permettre de
        récupérer votre compte étant donné que l'ensemble de vos données auront été
        anonymisées, et qu'il n'y aura aucun moyen pour un administrateur de vous
        identifier comme propriétaire de ce compte.
      </p>
    `
  },
  buttonLabel: {
    id: "profile.anonymization.buttonLabel",
    defaultMessage: "Anonymiser mes données"
  },
  confirmAnonymization: {
    id: "profile.anonymization.confirmAnonymization",
    defaultMessage: "Confirmer l'anonymisation"
  },
  cancelAnonymization: {
    id: "profile.anonymization.cancelAnonymization",
    defaultMessage: "Annuler l'anonymisation"
  },
  confirmationMessage: {
    id: "profile.anonymization.confirmationMessage",
    defaultMessage: `
      <p>
        Attention ! Cette opération est irréversible, et vous n'aurez plus accès à votre
        compte utilisateur sur la plateforme.
      </p>
      <p>
        Êtes-vous sûr de bien vouloir anonymiser vos données ?
      </p>
    `
  }
});
